import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { 
  FaCheckCircle, 
  FaCode, 
  FaMobileAlt, 
  FaCertificate, 
  FaQuestionCircle,
  FaBriefcase 
} from 'react-icons/fa';
import SessionFlowTrigger from '../components/sessionflow/SessionFlowTrigger';

const MotionBox = motion(Box);

// Icon mapping
const iconMap = {
  FaCheckCircle,
  FaCode,
  FaMobileAlt,
  FaCertificate,
  FaQuestionCircle,
  FaBriefcase
};

const ValueCard = ({ icon, title, description, delay }) => (
  <MotionBox
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay }}
  >
    <VStack
      align="start"
      p={8}
      bg="white"
      borderRadius="2xl"
      boxShadow="0 4px 20px rgba(0,0,0,0.08)"
      h="full"
      _hover={{
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(16, 185, 129, 0.2)',
      }}
      transition="all 0.3s"
    >
      <Icon as={iconMap[icon]} boxSize={12} color="accent.green" mb={4} />
      <Heading size="md" color="brand.700" mb={3}>
        {title}
      </Heading>
      <Text color="brand.500" lineHeight="1.7">
        {description}
      </Text>
    </VStack>
  </MotionBox>
);

const ValueProposition = ({ data }) => {
  return (
    <Box py={20} bg="brand.50">
      <Container maxW="container.xl">
        <VStack spacing={4} mb={16} textAlign="center">
          <Heading 
            size="2xl" 
            color="brand.800"
            fontWeight="900"
          >
            {data.title}
          </Heading>
          <Text fontSize="xl" color="brand.500" maxW="2xl">
            {data.subtitle}
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {data.values.map((value, index) => (
            <ValueCard key={index} {...value} />
          ))}
        </SimpleGrid>

        <Box textAlign="center" mt={12}>
          <SessionFlowTrigger {...data.sessionFlowButton} />
        </Box>
      </Container>
    </Box>
  );
};

export default ValueProposition;